import SearchModal from './SearchModal';

export default SearchModal;
